export default __webpack_public_path__ + "static/media/bp4.e2c1ae49.jpg";